import { BaseEditModel } from "model/BaseEditModel";
import { BaseModel } from "model/BaseModel";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import Produto from "model/administracao/cadastro/produto/Produto";
import Deposito from "./Deposito";
import ExecucaoPlanoQualidade from "model/qualidade/ExecucaoPlanoQualidade";
import Local from "model/patrimonio/Local";
import Patrimonio from "model/patrimonio/Patrimonio";

export default class ItemNotaFiscalEntrada implements BaseEditModel {

    id: number;
    codigo: string | null;
    key: string| null = null;
    sequencial: number;
    produto: Produto | null;
    quantidade: number;
    valorUnitario: number;
    lote: string;
    deposito: Deposito | null;
    validade: Date | null;
    execucaoPlanoQualidade: ExecucaoPlanoQualidade | null;
    itemPatrimonio: boolean;
    local: Local | null;
    patrimonios: Patrimonio[];

    constructor(
        id = 0,
        codigo = null,
        sequencial = 0,
        produto = new Produto(),
        quantidade = 0,
        valorUnitario = 0,
        lote = '',
        deposito = null,
        validade = null,
        execucaoPlanoQualidade = null,
        itemPatrimonio = false,
        local = null,
        patrimonios = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.sequencial = sequencial;
        this.produto = produto;
        this.quantidade = quantidade;
        this.valorUnitario = valorUnitario;
        this.lote = lote;
        this.deposito = deposito;
        this.validade = validade;
        this.execucaoPlanoQualidade = execucaoPlanoQualidade;
        this.itemPatrimonio = itemPatrimonio;
        this.local = local;
        this.patrimonios = patrimonios;
    }
}